module.exports = __webpack_public_path__ + "static/media/ic-more.57a7e0d3.svg";